import { ACTION_SWITCH_LEFT_MENU } from '../actionTypes';


// if we want to force showing/hiding menu we can pass bool value
export const actionSwitchLeftMenu = (isShow = null) => ({
  type: ACTION_SWITCH_LEFT_MENU,
  payload: { isShow },
});
